import api from "@/lib/api"
import { ROUTES } from "@/constants/routes"

export type AnomalyKind =
  | "orphan_invoice"
  | "drifting_timesheet"
  | "subtotal_mismatch"
  | "period_out_of_range"

export type AnomalySeverity = "error" | "warning" | "info"

export interface Anomaly {
  kind: AnomalyKind
  severity: AnomalySeverity
  invoice_id: number | null
  invoice_number: string | null
  message: string
  context: Record<string, unknown>
}

export interface AnomalyListResponse {
  count: number
  by_severity: Record<AnomalySeverity, number>
  anomalies: Anomaly[]
}

export const AnomalyAPI = {
  async list(firmId?: number): Promise<AnomalyListResponse> {
    const params = firmId ? `?firm=${firmId}` : ""
    const { data } = await api.get(`${ROUTES.API.INVOICE_ANOMALIES}${params}`)
    return data
  },

  async resetDriftingTimesheet(timesheetId: number): Promise<{ ok: true; timesheet_id: number }> {
    const { data } = await api.post(
      `${ROUTES.API.INVOICE_ANOMALIES}reset-timesheet/`,
      { timesheet_id: timesheetId },
    )
    return data
  },
}
